import { connect } from 'react-redux';
import { Login as LoginComponent } from './login';
import { BrandedLogin as BrandedLoginComponent } from './login/branded';
import { ForgotPassword as ForgotPasswordComponent } from './forgot-password';
import { Verify as VerifyComponent } from './verify';
import { ForgotPasswordSubmit as FGPasswordSubmitComponent } from './forgot-password-submit';
import {
  signUp,
  verify,
  signIn,
  forgotPassword,
  forgotPasswordSubmit,
} from './authentication.actions';

const Connected = connect(
  appState => ({ appState }),
  {
    signUp,
    verify,
    signIn,
    forgotPassword,
    forgotPasswordSubmit,
  }
);

export const Login = Connected(LoginComponent as any) as unknown as typeof LoginComponent;
export const BrandedLogin = Connected(BrandedLoginComponent as any) as unknown as typeof BrandedLoginComponent;
export const ForgotPassword = Connected(ForgotPasswordComponent as any) as unknown as typeof ForgotPasswordComponent;
export const Verify = Connected(VerifyComponent as any) as unknown as typeof VerifyComponent;
export const ForgotPasswordSubmit = Connected(FGPasswordSubmitComponent as any) as unknown as typeof FGPasswordSubmitComponent;
